<app-dialog-container
  [title]="'documentsAwaitingReadReceipt' | translate"
  [showConfirmButton]="false"
  [showCancelButton]="false"
  [hideActionsSeparator]="true"
>
  <div class="document-dashboard-table">
    @if (data.items.length === 0) {
      <p class="no-data">{{ 'noDataMatchingTheFilter' | translate }}</p>
    } @else {
      <app-main-table
        [tableData]="data.items"
        [displayedColumns]="displayedColumns"
        [disabledColumnHeaders]="disabledColumnHeaders"
        [columnTitlesMap]="columnTitlesMap"
        [searchingEnabled]="false"
        [filteringEnabled]="false"
        [sortingEnabled]="false"
        [paginationEnabled]="false"
        [elevationEnabled]="false"
        [hasRoutingForRow]="false"
        (rowHandler)="navigateToDocument($event)"
        viewMode="embedded"
      ></app-main-table>
    }
  </div>
</app-dialog-container>
